<mat-card class='p-24'>
  <mat-card-header>
    <mat-card-title>Cache</mat-card-title>
  </mat-card-header>
  @if (loading) {
    <mat-progress-bar mode='indeterminate'></mat-progress-bar>
  }
  <mat-card-actions>
    <button mat-flat-button [disabled]='loading' color='accent' (click)='clearCache()'>Pulisci cache</button>
    <button mat-flat-button [disabled]='loading' color='accent' (click)='optimizeCache()'>Ottimizza cache</button>
  </mat-card-actions>
</mat-card>